var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Tick",

    getDefaultProps () {
        return {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>tick</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="tick" stroke="currentColor" strokeWidth="0.5" fill="currentColor">
      <path d="M6.43841125,11.0504102 C6.51908096,11.050473 6.599709,11.0190027 6.66113782,10.956022 L12.9075756,4.55177434 C13.0305395,4.42570387 13.031214,4.22199482 12.9071638,4.09481061 C12.7839724,3.96850699 12.5843179,3.96842693 12.4614603,4.09438839 L6.43849197,10.2695208 L3.53893703,7.29671152 C3.41563831,7.17029781 3.2166775,7.16932803 3.09262731,7.29651218 C2.96943597,7.42281586 2.96874793,7.62688911 3.09282172,7.75409747 L6.21523993,10.9554004 C6.27685344,11.0185705 6.35736051,11.0504161 6.43797239,11.050599 L6.43841125,11.0504102 L6.43841125,11.0504102 Z" id="Rectangle-458"/>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/icons/tick.svg
 **/